import dateformat from 'dateformat';
import { convertTo24HourTimeFormat } from '../config/utils';
import { HR } from '../config/constants';
import { COUNTRYCODE, COUNTRYNAME } from './util-constants';

interface RedirectParams {
  source: any;
  destination: any;
  startDate: any;
  endDate: any;
  rf: string;
  package_id: string;
  stopOvers: any[];
}

export const createUnificationRedirectUrl = ({
  source,
  destination,
  startDate,
  endDate,
  rf,
  package_id,
  stopOvers
}: RedirectParams): string => {
  const { date: sd = new Date(), time: sTime = '' } = startDate;
  const { date: ed = new Date(), time: eTime = '' } = endDate;
  
  const { 
    name = '', 
    place_id = '', 
    city_name = '', 
    state = '', 
    address = '', 
    latitude = '', 
    longitude = '', 
    pincode = '', 
    google_city = '', 
    is_city = false, 
    is_airport = false 
  } = source;
  
  const { 
    name: dname = '', 
    place_id: dplace_id = '', 
    city_name: dcity_name = '', 
    state: dstate = '', 
    address: daddress = '', 
    latitude: dlatitude = '', 
    longitude: dlongitude = '', 
    pincode: dpincode = '', 
    google_city: dgoogle_city = '', 
    is_city: dis_city = false, 
    is_airport: dis_airport = false 
  } = destination;

  const startTime = convertTo24HourTimeFormat(sTime);
  const endTime = convertTo24HourTimeFormat(eTime);

  // Create fromCity object
  const fromCity = {
    latitude: parseFloat(latitude) || 0,
    longitude: parseFloat(longitude) || 0,
    pincode: pincode || null,
    place_id: place_id || '',
    city: city_name || '',
    google_city: google_city || '',
    state: state || '',
    country: COUNTRYNAME,
    country_code: COUNTRYCODE,
    is_city: is_city,
    is_airport: is_airport,
    google_address: address || '',
    address: name || ''
  };

  // Create toCity object - null for HR trips
  const toCity = rf === HR ? null : {
    latitude: parseFloat(dlatitude) || 0,
    longitude: parseFloat(dlongitude) || 0,
    pincode: dpincode || null,
    place_id: dplace_id || '',
    city: dcity_name || '',
    google_city: dgoogle_city || '',
    state: dstate || '',
    country: COUNTRYNAME,
    country_code: COUNTRYCODE,
    is_city: dis_city,
    google_address: daddress || '',
    address: dname || ''
  };

  const tripTypeParam = rf?.toUpperCase();
  const departDate = dateformat(sd, 'dd-mm-yyyy');
  const returnDate = dateformat(ed, 'dd-mm-yyyy');
  const pickupTime = startTime.split(' ')[0] || '10:00';
  const dropTime = endTime.split(' ')[0];

  // Format stopOvers for the URL - only include if not hr or at
  const formattedStopOvers = (rf === HR || rf === 'at') ? [] : stopOvers.map(stop => {
    const stopData = stop?.value || {};
    return {
      latitude: parseFloat(stopData.latitude) || 0,
      longitude: parseFloat(stopData.longitude) || 0,
      pincode: stopData.pincode || null,
      place_id: stopData.place_id || '',
      city: stopData.city_name || stopData.google_city || '',
      google_city: stopData.google_city || stopData.city_name || '',
      state: stopData.state || '',
      country: COUNTRYNAME,
      country_code: COUNTRYCODE,
      is_city: stopData.is_city || false,
      is_airport: stopData.is_airport || false,
      google_address: stopData.address || '',
      address: stopData.address || ''
    };
  });

  // Format packageKey for hr trips - convert PKG_30_3 to 3_30
  let formattedPackageKey = '';
  if (rf === HR && package_id) {
    const packageParts = package_id.replace('PKG_', '').split('_');
    if (packageParts.length === 2) {
      formattedPackageKey = `${packageParts[1]}_${packageParts[0]}`;
    }
  }

  // Build base URL
  let redirectUrl = `http://qa.goibibo.com:1080/cabs/listing?fromCity=${encodeURIComponent(JSON.stringify(fromCity))}&toCity=${encodeURIComponent(JSON.stringify(toCity))}&tripType=${tripTypeParam}&departDate=${departDate}&pickupTime=${pickupTime}&intlFlow=false&returnDate=${returnDate}&dropTime=${dropTime}`;
  
  // Only append stopOvers if it has values (not for hr and at trips)
  if (formattedStopOvers?.length > 0) {
    redirectUrl += `&stopOvers=${encodeURIComponent(JSON.stringify(formattedStopOvers))}`;
  }
  
  // Only append packageKey if it has a value
  if (formattedPackageKey) {
    redirectUrl += `&packageKey=${formattedPackageKey}`;
  }

  return redirectUrl;
};
